var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "#BDBDBA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2743_218921)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2743_218921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5006 22.1667C29.2562 22.1667 29.0423 22.075 28.859 21.8917L24.0007 17.0334L19.1423 21.8917C18.7757 22.2584 18.1951 22.2584 17.859 21.8917C17.4923 21.525 17.4923 20.9445 17.859 20.6084L23.359 15.1084C23.7257 14.7417 24.3062 14.7417 24.6423 15.1084L30.1423 20.6084C30.509 20.975 30.509 21.5556 30.1423 21.8917C29.959 22.075 29.7451 22.1667 29.5006 22.1667Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3562 33.1667H17.6451C16.0868 33.1667 14.834 31.9139 14.834 30.3555V26.6889C14.834 26.1694 15.2312 25.7722 15.7507 25.7722C16.2701 25.7722 16.6673 26.1694 16.6673 26.6889V30.3555C16.6673 30.9055 17.0951 31.3333 17.6451 31.3333H30.3562C30.9062 31.3333 31.334 30.9055 31.334 30.3555V26.6889C31.334 26.1694 31.7312 25.7722 32.2506 25.7722C32.7701 25.7722 33.1673 26.1694 33.1673 26.6889V30.3555C33.1673 31.9139 31.9145 33.1667 30.3562 33.1667Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0007 28.4917C23.4812 28.4917 23.084 28.0945 23.084 27.575V16.7278C23.084 16.2084 23.4812 15.8112 24.0007 15.8112C24.5201 15.8112 24.9173 16.2084 24.9173 16.7278V27.575C24.9173 28.0945 24.5201 28.4917 24.0007 28.4917Z",
    fill: "#1A1A1A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2743_218921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14 14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2743_218921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.3333,
    height: 18.3333,
    fill: "white",
    transform: "translate(14.834 14.8334)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.8984b1bfc953b5148c99693f52e04b04.svg";
export { ForwardRef as ReactComponent };